import React from "react";

const FILTVChannelCard = ({ channel, active, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`relative w-full rounded-xl p-3 text-left transition-all duration-200
            ${active
                ? "bg-purple-700 shadow-lg shadow-purple-700/40 scale-[1.02]"
                : "bg-zinc-900 hover:bg-zinc-800"
            }`}
        >
            <div className="flex items-center justify-between">
                <span className="text-2xl">{channel.emoji}</span>
                <span
                    className={`w-2 h-2 rounded-full ${
                        channel.hasAd ? "bg-red-500 animate-pulse" : "bg-zinc-600"
                    }`}
                />
            </div>

            <div className="mt-1 font-bold text-white">{channel.lcn}</div>
            <div className="text-xs text-zinc-300 truncate">{channel.title}</div>

            {active && (
                <div className="mt-1 text-red-200 text-[10px] font-bold">● LIVE</div>
            )}
        </button>
    );
};

export default FILTVChannelCard;
